import { DeviceRestrictionType, Section } from '@models/section';

export function cleanSectionName(sectionName: string): string {
    return sectionName
        .split('-')
        .map((word) => word[0].toUpperCase() + word.substring(1))
        .join('');
}

export function shouldShowSectionByDevice(isMobile: boolean, deviceRestrictionType?: DeviceRestrictionType): boolean {
    return (
        !deviceRestrictionType ||
        deviceRestrictionType === 'none' ||
        (deviceRestrictionType === 'desktopOnly' && !isMobile) ||
        (deviceRestrictionType === 'mobileOnly' && isMobile)
    );
}

export function shouldShowSectionByPageVariant(
    selectedPageVariant: string | null,
    pageVariants: string[] | null,
    section: Section
): boolean {
    let showSection = true;

    // If page has no variants, show all sections
    if (!pageVariants || pageVariants.length === 0) {
        return true;
    }

    // If a section has a variant allowlist, only show it if the selected page variant is in the allowlist
    if (section.jsonContent.variantAllowlist?.length) {
        // manage inconsistencies between page variants and section allowlist
        // only consider allowlist items that are also in pageVariants
        const filteredAllowlist = section.jsonContent.variantAllowlist.filter((variant) =>
            pageVariants.includes(variant)
        );

        if (!filteredAllowlist.length) {
            return true;
        }

        if (selectedPageVariant) {
            showSection = filteredAllowlist.includes(selectedPageVariant);
        } else {
            showSection = false;
        }
    }

    return showSection;
}
